import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import type { LandingAPI } from '../../../../shared/types/api';

/**
 * Public: standard plan pricing for the visitor's country (no auth).
 *
 * Onboarding v3 shows the seat price during the questionnaire, ahead of the
 * auth gate, so it can't use the authenticated payment-options endpoint.
 * Prices come back in the smallest currency unit (cents/pence); render them
 * with formatPrice() from utils/priceUtils rather than dividing at callsites,
 * so symbol position and zero-decimal currencies stay correct.
 */
export function useLandingPricing() {
  return useQuery({
    queryKey: ['landing-pricing'],
    queryFn: async (): Promise<LandingAPI.GetPublicPricingResponse> => {
      return api.get('/landing/pricing');
    },
    staleTime: 30 * 60 * 1000,
    retry: 1,
  });
}
